import { getAccessToken } from "@/utils/authHeader";
import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: '/login',
    name: 'full-width',
    component: () => import('../views/layout/FullLayout.vue'),
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import('../views/auth/LoginView.vue'),
        meta: { requiresLogin: false },
      },
      {
        path: "/password/forgot",
        name: "password-forgot",
        component: () => import('../views/auth/PasswordForgot.vue'),
        meta: { requiresLogin: false },
      },
      {
        path: "/password/forgot/done",
        name: "password-forgot-done",
        component: () => import('../views/auth/PasswordForgotDone.vue'),
        meta: { requiresLogin: false },
      },
      {
        path: '/password/reset/:signature',
        name: 'password-reset',
        component: () => import('../views/auth/PasswordReset.vue'),
        meta: { requiresLogin: false },
      },
      {
        path: '/password/reset/done',
        name: 'password-reset-done',
        component: () => import('../views/auth/PasswordResetDone.vue'),
        meta: { requiresLogin: false },
      },
    ],
  },
  {
    path: "/",
    name: "root",
    component: () => import('../views/layout/MainLayout.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('../views/HomeView.vue'),
      },
      // アカウント
      {
        path: "/account/profile",
        name: "account-profile",
        component: () => import('../views/account/ProfileView.vue'),
      },
      {
        path: "/account/change-password",
        name: "account-change-password",
        component: () => import('../views/account/ChangePassword.vue'),
        meta: { navActiveLink: 'account-profile' },
      },
      {
        path: "/account/sub-accounts",
        name: "account-sub-accounts",
        component: () => import('../views/account/SubAccounts.vue'),
      },
      {
        path: "/account/sub-accounts/add",
        name: "account-sub-account-add",
        component: () => import('../views/account/SubAccount.vue'),
        meta: { navActiveLink: 'account-sub-accounts' },
      },
      {
        path: "/account/sub-accounts/:pk",
        name: "account-sub-account-change",
        component: () => import('../views/account/SubAccount.vue'),
        meta: { navActiveLink: 'account-sub-accounts' },
      },
      // お知らせ
      {
        path: "/notifications",
        name: "notifications",
        component: () => import('../views/notification/NotificationList.vue'),
      },
      {
        path: "/notifications/:pk",
        name: "notification-detail",
        component: () => import('../views/notification/NotificationDetail.vue'),
        meta: { navActiveLink: 'notifications' },
      },
      // 出勤
      {
        path: '/attendance',
        name: 'attendance-current-month',
        component: () => import('../views/attendance/AttendanceMonthly.vue'),
      },
      {
        path: '/attendance/year/:year/month/:month',
        name: 'attendance-monthly',
        component: () => import('../views/attendance/AttendanceMonthly.vue'),
        meta: { navActiveLink: 'attendance-current-month' },
      },
      // 注文
      {
        path: '/order/orders',
        name: 'order-list',
        component: () => import('../views/order/OrderList.vue'),
      },
      {
        path: '/order/orders/year/:year/month/:month',
        name: 'orders-monthly',
        component: () => import('../views/order/OrderList.vue'),
        meta: { navActiveLink: 'order-list' },
      },
      {
        path: '/order/orders/:pk/preview',
        name: 'orders-detail-preview',
        component: () => import('../views/order/OrderDetail.vue'),
        meta: { navActiveLink: 'order-list' },
      },
      // 請求
      {
        path: '/request/requests',
        name: 'request-list',
        component: () => import('../views/request/RequestList.vue'),
      },
      {
        path: '/request/requests/year/:year/month/:month',
        name: 'request-monthly',
        component: () => import('../views/request/RequestList.vue'),
        meta: { navActiveLink: 'request-list' },
      },
      {
        path: '/request/requests/:pk/preview',
        name: 'request-detail-preview',
        component: () => import('../views/request/RequestDetail.vue'),
        meta: { navActiveLink: 'request-list' },
      },
    ],
  },
  {
    path: "/:catchAll(.*)",
    name: "not-found",
    component: () => import('../views/NotFound.vue'),
    meta: { requiresLogin: false },
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.requiresLogin === false) && !getAccessToken()) {
    next({ name: 'login', query: { next: to.fullPath } })
  } else {
    next()
  }
});

export default router;
